import { render } from "./ExamplePage.vue?vue&type=template&id=38e1bfa4"
import script from "./ExamplePage.vue?vue&type=script&lang=js"
export * from "./ExamplePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__